import { AddIcon, DeleteIcon, ViewIcon } from '@chakra-ui/icons'
import { Box, Button, ButtonGroup, Flex, Input, Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { BiEditAlt } from 'react-icons/bi'
import DeleteBtn from './DeleteBtn'
import { useNavigate } from 'react-router-dom'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'

const Product = () => {
    const [product,setProduct]=useState([])
    const [search,setSearch]=useState("")
    const [flag,setFlage]=useState(true)
    const [page,setPage]=useState(1)
    const navigate=useNavigate()
    let url=process.env.REACT_APP_DEV_URL
    const [count,setCount]=useState(0)

    const getCount=async()=>{
      try {
        let data =await fetch(`${url}/product`)
        data=await data.json()
        console.log(data);
        setCount(data.data.length)
    } catch (error) {
        console.log(error);
    }
    }

    const getData=async()=>{
            try {
                let data =await fetch(`${url}/product?page=${page}`)
                data=await data.json()
                console.log(data);
                setProduct(data.data)
            } catch (error) {
                console.log(error);
            }
    }
    const handleSearch=async()=>{
 
      try {
        if(search){
          let data=await fetch(`${url}/product/search/${search}`)
          data=await data.json()
          setProduct(data.data)
        }else{
          getData()
        }
      } catch (error) {
        console.log(error);
      }
    }
    const handleDelete=async(id)=>{
      try {
       
        let data=await fetch(`${url}/product/delete/${id}`,
        {
          method:"DELETE",
          headers:{
            "Content-Type": "application/json"
          },
        })
        data=await data.json()
        getData()
      } catch (error) {
        console.log(error);
      }
    }
    useEffect(()=>{
        getData()
        getCount()
    },[page])
  return (
    <Box p="4">
        <Flex gap={5} justifyContent={"space-between"}>
            <Button leftIcon={<AddIcon/>} color={"#f9a526"} bgColor={"black"}  _hover={{color:"black",bgColor:"#f9a526"}} onClick={()=>navigate("/admin/product/add")}>
                Add New
            </Button>
            <Box>
            Search:<Input w="150px" onBlur={()=>setFlage(true)} onChange={(e)=>{setFlage(false);setSearch(e.target.value)}}  value={search} onKeyUp={handleSearch} />
            </Box>
        </Flex>
        <br/>
        <TableContainer border={"1px solid #161616"} borderRadius={"20px"}>
  <Table variant='simple'>
    <TableCaption borderTop={"1px solid #161616"} bgColor={"#f9a526"} >There Are {count} Products</TableCaption>
    <Thead>
      <Tr bgColor={"black"}>
        <Th color={"#f9a526"} >#</Th>
        <Th color={"#f9a526"}>Name</Th>
        <Th color={"#f9a526"}>caption</Th>
        <Th color={"#f9a526"} >Category</Th>
        <Th color={"#f9a526"} >Action</Th>
      </Tr>
    </Thead>
    <Tbody>
    {product?.map((e,i)=>{
        return <Tr >
            <Td> {i+1} </Td>
            <Td>{e.name}</Td>
            <Td>{e.caption}</Td>
            <Td>{e.category?.name}</Td>
            <Td>  
                <ButtonGroup>
                <Button leftIcon={<ViewIcon/>} color={"#f9a526"} bgColor={"black"}  _hover={{color:"black",bgColor:"#f9a526"}} onClick={()=>navigate(`/admin/product/${e.slug}`)}>View</Button>
                <Button leftIcon={<BiEditAlt/>} border="1px solid #f9a526" _hover={{color:"black",bgColor:"#f9a526"}}  onClick={()=>navigate(`/admin/product/edit/${e.slug}`)}>Edit</Button>
                <DeleteBtn handleDelete={()=>handleDelete(e._id)}/>
                </ButtonGroup>
            </Td>
        </Tr>
    })}
    </Tbody>
  </Table>
</TableContainer>
<br />
<Flex justifyContent={"center"}>
{flag&&<div>
          <Button variant={"outline"}  border="1px solid #f9a526" bgColor={"black"} color={"#f9a526"} isDisabled={page==1} onClick={()=>setPage(page-1)}><BsArrowLeft/></Button>
          <Button>{page}</Button>
          <Button variant={"outline"}  border="1px solid #f9a526" bgColor={"black"} color={"#f9a526"} isDisabled={page>Math.floor(count/12)} onClick={()=>setPage(page+1)}><BsArrowRight/></Button>
        </div>
        }
</Flex>
    </Box>
  )
}

export default Product
